// src/pages/DashboardPage.jsx
import React, { useState, useEffect } from 'react';
import { Plus, Type, LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { usePages } from '../hooks/usePages';
import PageCard from '../components/dashboard/PageCard';
import { copyText, showCenterToast } from '../utils/copyToClipboard';

export default function DashboardPage({ onCreateNew, onEditPage }) {
  const { user, logout } = useAuth();
  const { pages, loadPages, deletePage } = usePages();
  const [copiedUrl, setCopiedUrl] = useState(null);

  useEffect(() => {
    loadPages();
  }, []);

  const handleLogout = async () => {
    await logout();
  };

  const generatePageUrl = (page) => {
    return `${window.location.origin}?id=${page.id}`;
  };

  const handleCopy = async (page) => {
    const url = generatePageUrl(page);
    try {
      await copyText(url);
      setCopiedUrl(page.id);
      showCenterToast('链接已复制');
      setTimeout(() => setCopiedUrl(null), 2000);
    } catch (err) {
      console.error('复制失败:', err);
      showCenterToast('复制失败，请手动复制', false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <Type className="w-5 h-5 text-white" />
              </div>
              <h1 className="text-xl font-bold text-gray-900">H5页面生成器</h1>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-700">欢迎, {user?.name}</span>
              <button
                onClick={handleLogout}
                className="text-gray-600 hover:text-gray-900 flex items-center space-x-1"
              >
                <LogIn className="w-4 h-4 rotate-180" />
                <span>退出</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900">我的页面</h2>
          <button
            onClick={onCreateNew}
            className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          >
            <Plus className="w-4 h-4" />
            <span>新建页面</span>
          </button>
        </div>
        {pages.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Type className="w-8 h-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">暂无页面</h3>
            <p className="text-gray-500 mb-6">点击"新建页面"开始创建您的第一个H5页面</p>
            <button
              onClick={onCreateNew}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
            >
              新建页面
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {pages.map((page) => (
              <PageCard
                key={page.id}
                page={page}
                onEdit={onEditPage}
                onCopy={handleCopy}
                onDelete={deletePage}
                copiedUrl={copiedUrl}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}